export default __webpack_public_path__ + "static/media/facebook.4178d148.svg";